import { useCallback, memo, useMemo } from 'react';
import { useSMARTGoalPageState } from 'context/SMARTGoalAppContext';
import { DashboardVariantID } from 'Components/Dashboard/DashboardHelper';
import { formatDuration, intervalToDuration } from 'date-fns';
import { useQueryFetch } from '@ace/react-utilities';
import { isValidDate } from 'utils/dateUtils';

export const queryProps = {
    userGoals: {
        componentName: 'SMARTGoalsFormComponent',
        retrievalUrl: `/api/dashboard/smart-goals/user-goals-display/${DashboardVariantID}/`,
        queryKey: ['SMARTGoalsFormComponent', `/api/dashboard/smart-goals/user-goals-display/${DashboardVariantID}/`]
    },
    updateUserGoal: {
        componentName: 'SMARTGoalsUpdateFormComponent',
        callbackUrl: `/api/dashboard/smart-goals/update/${DashboardVariantID}/`
    },
    appSteps: {
        componentName: 'SMARTGoalsComponent',
        retrievalUrl:  `/api/dashboard/smart-goals/display/${DashboardVariantID}/`,
        queryKey: ['SMARTGoalsComponent', `/api/dashboard/smart-goals/display/${DashboardVariantID}/`]
    }
};

export const SMART_GOAL_DATA_EVENTS = {
    ON_UPDATE_SETTLED: 'ON_UPDATE_SETTLED',
    ON_OVERLAY_HIDDEN: 'ON_OVERLAY_HIDDEN'
};

export const smartGoalsSelect = memo((data) => {
    const byStepKey = data.Pages.reduce((byStepKey, page) => {
        byStepKey[page.SMARTGoalStepKey] = page;
        return byStepKey;
    }, {});
    const allKeys = Object.keys(byStepKey);

    data.Goals = byStepKey;
    data.GoalKeys = allKeys;

    return data;
});

export const timeToCompleteFN = (StartDate, EndDate) => {
    if (!StartDate || !EndDate) {
        return null;
    }

    const duration = intervalToDuration({
        start: isValidDate(StartDate) ? StartDate : new Date(StartDate),
        end: isValidDate(EndDate)? EndDate : new Date(EndDate)
    });

    return formatDuration({...duration, months: (duration.months || 0) + ((duration.years || 0) * 12), years: 0 }, { zero: false, format: ['months', 'days'] }); //'years', 'weeks', 
}

export const useSMARTGoalStepState = () => {
    const { currentPage, showStep } = useSMARTGoalPageState();

    const { data: stepKeys } = useQueryFetch(queryProps.appSteps.componentName, queryProps.appSteps.retrievalUrl, { 
        select: useCallback((data) => (data.Pages.map(page => page.SMARTGoalStepKey)), [])
    });

    return useMemo(() => ({
        currentStep: showStep ? currentPage-1 : 0,
        currentStepIndex: showStep ? currentPage-2 : -1,
        currentStepKey: showStep ? stepKeys[currentPage-2]: null
    }), [showStep, currentPage, stepKeys]);
}